// extracted by mini-css-extract-plugin
export default {"modal":"AddStudentModal_modal__TXDXi","form":"AddStudentModal_form__OmnFS","invitationRow":"AddStudentModal_invitationRow__4N-28","showMore":"AddStudentModal_showMore__jdEWM"};